import { Poppins, Courier_Prime } from "next/font/google"
import localFont from "next/font/local"

export const FONT_WEIGHTS = ["400", "600", "700", "900"] as const

export const poppins = Poppins({
  weight: ["400", "600", "700", "900"],
  subsets: ["latin"],
  style: ["normal", "italic"],
})

export const courierPrime = Courier_Prime({
  weight: ["400"],
  subsets: ["latin"],
  style: ["italic"],
})

export const lunchbox = localFont({
  src: "./fonts/lunchbox/kimmy_design_-_lunchboxslabbold-webfont.woff2",
})
